import {
  SET_LIST_LINKUP_DATA,
  SET_LIST_LINKUP_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listLinkupData: null,
  listLinkupDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_LINKUP_DATA:
      return {
        ...state,
        loading: false,
        listLinkupData: action.listLinkupData,
      };

    case SET_LIST_LINKUP_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listLinkupDataTotal: action.listLinkupDataTotal,
      };

    default:
      return { ...state };
  }
};
